import BackIcon from "./../../../images/BackIcon.svg";
import { Card, Row, Col, Button } from "react-bootstrap";
import { FaFilePdf, FaLink, FaTrashAlt, FaSync } from "react-icons/fa";
import "./style.css";
import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
    getProjectById,
    updateProjectStatus,
} from "../../../store/actions/ProjectActions";
import defaultProfile from "../../../images/avatar/defaultuser.png";
import {
    formatDateProject,
    getAgeFromDob,
    getStatusSelectStyles,
} from "../../../utils/functions/date";
import { ArtistDetails as ArtistDataComponent, ProjectDetailsCard } from "./ProjectDetails";
import { getArtistById } from "../../../store/actions/ArtistsActions";
import ArtistAvatar, { getImageUrl } from "../Artist/ArtistAvatar";
import { artistValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateUI from "../Artist/AddUpdateUI";
import FormModal from "../../components/Modal/FormModal";
import AddUpdateArtist from "../Artist/AddUpdate";
import { globaltriggerDelete } from "../../components/CustomTable";

const ArtistDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { artistDetails, isLoading } = useSelector((state) => state.artists);
    const navigate = useNavigate();
    const [projectData, setProjectData] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (id) {
            dispatch(getArtistById(id));
        }
    }, [id]);

    if (isLoading) return <p>Loading artist...</p>;
    if (!artistDetails) return <p>No artist details found.</p>;

    const refetchData = () => {
        dispatch(getArtistById(id));
    }

    const closeModal = () => {
        refetchData();
        setShowModal(false);
    };

    const modalConfig = {
        initialValues: {
            _id: artistDetails?._id,
            firstName: artistDetails?.firstName,
            lastName: artistDetails?.lastName,
            dob: artistDetails?.dob,
            email: artistDetails?.email,
            mobileNumber: artistDetails?.mobileNumber,
            gender: artistDetails?.gender,
            state: artistDetails?.state?._id,
            city: artistDetails?.city?._id,
            instagramProfile: artistDetails?.instagramProfile,
            profile_image: artistDetails?.profile_image,
            description: artistDetails?.description,
            hearAbout: artistDetails?.hearAbout || "admin",
            referenceLinks: artistDetails?.referenceLinks,
            portfolioPdf: artistDetails?.portfolioPdf,
        },
        validationSchema: artistValidationSchema,
        apiUrl: "artist/",
        FormComponent: (props) => <AddUpdateArtist {...props} showrole={false} />,
        addTitle: "Add Artis",
        updateTitle: "Update Artist",
        extraProps: {},
        closeModal: closeModal,
        showModal,
        setShowModal,
    };

    const onRowClick = (projectData) => {
        setProjectData(projectData);
        // navigate(`/projects/${projectId}`);
    }

    const backPress = () => { setProjectData(null); }

    const deleteArtist = () => {
        globaltriggerDelete({ endPoint: `artist/${artistDetails._id}`, dispatch, callback: () => navigate(`/artists`) });
    }

    return (
        <div>
            <PageTitle
                activeMenu="Artists"
                motherMenu="Form"
                pageContent="Artist Details"
                onClick={() => projectData ? backPress() : navigate(-1)}
            />
            <div className="container-mxw">
                {projectData ? (<ProjectDetailsCard project={projectData} />) : (
                    <>
                        <div
                            className="p-3 my-2 d-flex mb-4 px-4"
                            style={{
                                background: "#FFF",
                            }}
                        >
                            <div className="main-title d-flex align-items-center justify-content-between w-100">
                                {/* Avatar */}
                                <div className="d-flex align-items-start gap-2">
                                    <div
                                        className="rounded-circle border d-flex align-items-center justify-content-center me-3"
                                        style={{ width: "70px", height: "70px" }}
                                    >
                                        <img src={getImageUrl(artistDetails?.profile_image)} style={{ width: "60px", height: "60px", borderRadius: "50%" }} />
                                    </div>
                                    <div className="me-4">
                                        <h1 className="m-0">{`${artistDetails?.firstName} ${artistDetails?.lastName}`}</h1>
                                        <p>
                                            {getAgeFromDob(artistDetails?.dob)} {`${artistDetails?.city?.name ? `, ${artistDetails?.city?.name}` : ""}`}
                                        </p>
                                    </div>
                                    <div className="d-flex gap-2 align-items-center" style={{
                                        border: "1px solid black",
                                        borderRadius: "4.3px",
                                        padding: "4px 6.5px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase"
                                    }}>
                                        <span className="success-icon fs-14">Showcased</span>
                                        <span className="badge bg-success">
                                            {artistDetails?.projects?.filter((p) => p.status === "Showcase").length ??
                                                0}
                                        </span>
                                    </div>
                                    <div className="d-flex gap-2 align-items-center" style={{
                                        border: "1px solid black",
                                        borderRadius: "4.3px",
                                        padding: "4px 6.5px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase"
                                    }}>
                                        <span className="">Projects</span>
                                        <span className="badge bg-dark">{artistDetails?.projects?.length ?? 0}</span>
                                    </div>
                                </div>
                                <div className="d-flex gap-2">
                                    <div className="">
                                        <button className="btn btn-secondary" onClick={() => setShowModal(true)}>Edit</button>
                                    </div>
                                    <div className="">
                                        <button className="btn btn-secondary" onClick={deleteArtist}>Delete</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="container-fuild p-3">
                            <div className="row">
                                {/* LEFT SIDE - About Lead Artist */}
                                <div className="col-lg-12 p-0">
                                    <div className="card">
                                        <div className="card-header bg-white border-0 pb-0">
                                            <h5 className="mb-0 text-primary fw-semibold project-title">
                                                About Artist
                                            </h5>
                                        </div>
                                        <div className="card-body row">
                                            <div className="col-6">
                                                <ArtistDataComponent projectDetails={{ artist: artistDetails }} />
                                            </div>
                                            <div className="col-6">

                                                {artistDetails?.portfolioPdf ? (
                                                    <a
                                                        href={getImageUrl(artistDetails?.portfolioPdf)}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-decoration-none"
                                                    >
                                                        <div
                                                            className="d-flex align-items-center justify-content-between border rounded p-2 mb-3"
                                                            style={{
                                                                minHeight: "50px",
                                                            }}
                                                        >
                                                            <span>
                                                                <FaFilePdf className="text-primary me-2" />
                                                                {/* Personal Portfolio */}
                                                                {artistDetails?.portfolioPdf
                                                                    ? "Personal Portfolio"
                                                                    : "Add Supporting Material"}
                                                            </span>
                                                            <span>
                                                                {/* <FaSync className="me-3" />
                                                                <FaTrashAlt className="text-primary" /> */}
                                                            </span>
                                                        </div>
                                                    </a>
                                                ) : null}
                                                {artistDetails?.referenceLinks?.length > 0 ? (
                                                    <>
                                                        <h6 className="fw-semibold my-4" style={{ fontSize: "18px" }}>
                                                            Additional References
                                                        </h6>
                                                        {artistDetails?.referenceLinks?.map((ele, index) => (
                                                            <a
                                                                href={ele}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="text-decoration-none"
                                                            >
                                                                <div
                                                                    className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                                                                    style={{
                                                                        minHeight: "50px",
                                                                    }}
                                                                >
                                                                    <span>
                                                                        <FaLink className="text-blue me-2" />
                                                                        Link to Reference Work - {index + 1}
                                                                    </span>
                                                                </div>
                                                            </a>
                                                        ))}
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fuild p-3">
                            <div className="row">
                                {/* LEFT SIDE - About Lead Artist */}
                                <div className="col-lg-12 p-0">
                                    <div className="card">
                                        <div className="card-header bg-white border-0 pb-0">
                                            <h5 className="mb-0 text-primary fw-semibold project-title">
                                                Projects
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            {artistDetails?.projects?.length > 0 ? (
                                                artistDetails.projects.map((project, index) => (
                                                    <div key={index} onClick={() => onRowClick(project)} className="row mb-3 p-3 cursor-pointer" style={{ borderBottom: "0.6px solid #EEEEEE" }}>
                                                        <div className="col-3">
                                                            <label className="fs-14" style={{ color: "#B5B7C0" }}>Project</label>
                                                            <div
                                                                className="position-relative artist-avatar text-center align-items-center artist-avatar d-flex gap-2 position-relative text-center"
                                                            >
                                                                <img src={project?.squareImage ? getImageUrl(project?.squareImage) : defaultProfile} style={{ height: "30px", width: "30px" }} className="mb-1" />
                                                                <p className="fw-bold fs-14">{project.conceptTitle}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-3">
                                                            <label className="fs-14" style={{ color: "#B5B7C0" }}>Art Form</label>
                                                            <p className="fw-bold">{project.artForm?.name} {project?.genre ? ` | ${project.genre?.name}` : ''} </p>
                                                        </div>
                                                        <div className="col-2">
                                                            <label className="fs-14" style={{ color: "#B5B7C0" }}>Role</label>
                                                            <p className="fw-bold">{project.ArtistProject?.length > 0 ? project.ArtistProject[0]?.role : "-"}</p>
                                                        </div>
                                                        <div className="col-2">
                                                            <label className="fs-14" style={{ color: "#B5B7C0" }}>Status</label>
                                                            <p className="fw-bold">{project.status}</p>
                                                        </div>
                                                        <div className="col-2 text-center">
                                                            <label className="fs-14" style={{ color: "#B5B7C0" }}>Action</label>
                                                            <p className="fw-bold text-primary"><i class="fa-solid fa-eye"></i></p>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <p>No projects found.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {showModal ? (
                <FormModal
                    modalConfig={{
                        ...modalConfig,
                    }}
                />
            ) : null}
        </div>
    );
};

export default ArtistDetails;
